import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Testimonials = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: t('home.testimonials.items.amit.name'),
      role: t('home.testimonials.items.amit.role'),
      text: t('home.testimonials.items.amit.text'),
      rating: 5
    },
    {
      name: t('home.testimonials.items.priya.name'),
      role: t('home.testimonials.items.priya.role'),
      text: t('home.testimonials.items.priya.text'),
      rating: 5
    },
    {
      name: t('home.testimonials.items.rajesh.name'),
      role: t('home.testimonials.items.rajesh.role'),
      text: t('home.testimonials.items.rajesh.text'),
      rating: 4
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-green mb-4">{t('home.testimonials.title')}</h2>
          <div className="w-24 h-1 bg-gold-primary mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-cream-off p-8 rounded-2xl relative shadow-sm hover:shadow-md transition-shadow">
              <Quote className="absolute top-4 right-4 text-gold-primary/20" size={40} />
              <div className="flex mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} className="text-gold-primary fill-gold-primary" size={16} />
                ))}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed">"{t.text}"</p>
              <div>
                <h4 className="font-bold text-dark-green">{t.name}</h4>
                <p className="text-sm text-gray-500">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
